const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    let allSettled2 = function(promises) {
      return Promise.all(
        promises.map(
          (p) => Promise.resolve(p).then(
            (value) => ({ status: "fulfilled", value }),
            (reason) => ({ status: "rejected", reason })
          )
        )
      );
    };
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = (cspNonceMeta == null ? void 0 : cspNonceMeta.nonce) || (cspNonceMeta == null ? void 0 : cspNonceMeta.getAttribute("nonce"));
    promise = allSettled2(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
        }
        link.crossOrigin = "";
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  function handlePreloadError(err) {
    const e = new Event("vite:preloadError", {
      cancelable: true
    });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
const groupGlobalModules = /* @__PURE__ */ Object.assign({ "../groups/footers/footer/footer.script-global.ts": () => __vitePreload(() => import("./footer.script-global-Dn2KGOVq.js"), true ? [] : void 0, import.meta.url), "../groups/popups/popup-age-verification/popup-age-verification.script-global.ts": () => __vitePreload(() => import("./popup-age-verification.script-global-DaIW566h.js"), true ? [] : void 0, import.meta.url), "../groups/popups/popup-countdown-promo/popup-countdown-promo.script-global.ts": () => __vitePreload(() => import("./popup-countdown-promo.script-global-pf62aFM7.js"), true ? [] : void 0, import.meta.url), "../groups/popups/popup-product-quickview/popup-product-quickview.script-global.ts": () => __vitePreload(() => import("./popup-product-quickview.script-global-Bq70fdnM.js"), true ? [] : void 0, import.meta.url), "../groups/popups/popup-promo/popup-promo.script-global.ts": () => __vitePreload(() => import("./popup-promo.script-global-ByYCP1y4.js"), true ? [] : void 0, import.meta.url), "../groups/popups/popup-sign-up/popup-sign-up.script-global.ts": () => __vitePreload(() => import("./popup-sign-up.script-global-Bq902Yci.js"), true ? [] : void 0, import.meta.url) });
Object.values(groupGlobalModules).forEach((module) => module());
const sectionsGlobalModules = /* @__PURE__ */ Object.assign({});
Object.values(sectionsGlobalModules).forEach((module) => module());
const pagesGlobalModules = /* @__PURE__ */ Object.assign({ "../pages/product/main-product/main-product.script-global.ts": () => __vitePreload(() => import("./main-product.script-global-CPV6a2t8.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/product-info-content/product-info-content.script-global.ts": () => __vitePreload(() => import("./product-info-content.script-global-B5okas_s.js"), true ? [] : void 0, import.meta.url), "../pages/search-filters/main-collection/section-main-collection.script-global.ts": () => __vitePreload(() => import("./section-main-collection.script-global-CbSzmd8K.js"), true ? [] : void 0, import.meta.url) });
Object.values(pagesGlobalModules).forEach((module) => module());
const utils = window.XotinyUtils;
utils == null ? void 0 : utils.attrBoolean;
utils == null ? void 0 : utils.clamp;
utils == null ? void 0 : utils.cloneDeep;
const componentDefine = utils == null ? void 0 : utils.componentDefine;
utils == null ? void 0 : utils.createAnimate;
utils == null ? void 0 : utils.createCssInJs;
utils == null ? void 0 : utils.appendStyle;
utils == null ? void 0 : utils.hash;
utils == null ? void 0 : utils.createDebounce;
utils == null ? void 0 : utils.debounce;
const delay = utils == null ? void 0 : utils.delay;
const DOMLoaded = utils == null ? void 0 : utils.DOMLoaded;
utils == null ? void 0 : utils.easings;
utils == null ? void 0 : utils.Emitter;
utils == null ? void 0 : utils.equal;
const each = utils == null ? void 0 : utils.each;
utils == null ? void 0 : utils.filter;
utils == null ? void 0 : utils.findIndex;
utils == null ? void 0 : utils.map;
utils == null ? void 0 : utils.reduce;
utils == null ? void 0 : utils.frameManager;
utils == null ? void 0 : utils.FrameManager;
const getAttrs = utils == null ? void 0 : utils.getAttrs;
utils == null ? void 0 : utils.imageUrl;
utils == null ? void 0 : utils.interpolate;
utils == null ? void 0 : utils.isMobile;
utils == null ? void 0 : utils.device;
utils == null ? void 0 : utils.os;
utils == null ? void 0 : utils.namingConvention;
utils == null ? void 0 : utils.objectKeys;
const objectParse = utils == null ? void 0 : utils.objectParse;
const objectValues = utils == null ? void 0 : utils.objectValues;
utils == null ? void 0 : utils.offset;
utils == null ? void 0 : utils.panGesture;
utils == null ? void 0 : utils.popper;
utils == null ? void 0 : utils.queryString;
utils == null ? void 0 : utils.rubberBandClamp;
const storage = utils == null ? void 0 : utils.storage;
utils == null ? void 0 : utils.throttle;
utils == null ? void 0 : utils.throwError;
utils == null ? void 0 : utils.typeOf;
utils == null ? void 0 : utils.XOStore;
utils == null ? void 0 : utils.getScrollbarWidth;
utils == null ? void 0 : utils.getBreakpointsOptions;
utils == null ? void 0 : utils.resizeAxis;
utils == null ? void 0 : utils.loadStyle;
utils == null ? void 0 : utils.loadScript;
utils == null ? void 0 : utils.range;
utils == null ? void 0 : utils.SVGPath;
utils == null ? void 0 : utils.inViewport;
utils == null ? void 0 : utils.wrapAroundRange;
const customElements = utils == null ? void 0 : utils.customElements;
utils == null ? void 0 : utils.contextUpdate;
utils == null ? void 0 : utils.stateUpdate;
const XoComponent = utils == null ? void 0 : utils.XoComponent;
utils == null ? void 0 : utils.XoHTMLDivElement;
utils == null ? void 0 : utils.XoHTMLElement;
utils == null ? void 0 : utils.imagesLoaded;
utils == null ? void 0 : utils.sectionXoBuiderObserver;
utils == null ? void 0 : utils.isBot;
utils == null ? void 0 : utils.openPopover;
utils == null ? void 0 : utils.closePopover;
utils == null ? void 0 : utils.popoverSupported;
utils == null ? void 0 : utils.isVimeo;
utils == null ? void 0 : utils.isYoutube;
utils == null ? void 0 : utils.playVideo;
utils == null ? void 0 : utils.pauseVideo;
utils == null ? void 0 : utils.getShopifySectionId;
utils == null ? void 0 : utils.getRootRoute;
const formatMoney = utils == null ? void 0 : utils.formatMoney;
utils == null ? void 0 : utils.requestIdleCallback;
utils == null ? void 0 : utils.cancelIdleCallback;
utils == null ? void 0 : utils.logger;
utils == null ? void 0 : utils.random;
utils == null ? void 0 : utils.damp;
utils == null ? void 0 : utils.createDampedValue;
utils == null ? void 0 : utils.createCache;
const ACTIVE = "xo-active";
const handlePasswordToggle = () => {
  const togglePasswords = document.querySelectorAll("#togglePassword");
  if (togglePasswords.length === 0) {
    return;
  }
  togglePasswords.forEach((togglePassword) => {
    var _a;
    const passwordField = (_a = togglePassword.previousElementSibling) == null ? void 0 : _a.querySelector('input[type="password"]');
    const eyeOpenPassword = togglePassword.querySelector(".xo-icon-open");
    const eyeHidePassword = togglePassword.querySelector(".xo-icon-hidden");
    if (!passwordField || !eyeOpenPassword || !eyeHidePassword) {
      return;
    }
    togglePassword.addEventListener("click", () => {
      const isPasswordField = passwordField.type === "password";
      passwordField.type = isPasswordField ? "text" : "password";
      if (isPasswordField) {
        eyeOpenPassword.classList.add(`${ACTIVE}`);
        eyeHidePassword.classList.add(`${ACTIVE}`);
      } else {
        eyeOpenPassword.classList.remove(`${ACTIVE}`);
        eyeHidePassword.classList.remove(`${ACTIVE}`);
      }
    });
  });
};
DOMLoaded(() => {
  handlePasswordToggle();
});
const snippetModules = /* @__PURE__ */ Object.assign({ "../snippets/action-scroll/action-scroll.script-global.ts": () => __vitePreload(() => import("./action-scroll.script-global-Bxca-FL-.js"), true ? [] : void 0, import.meta.url), "../snippets/cart/cart-free-shipping/cart-free-shipping.script-global.ts": () => __vitePreload(() => import("./cart-free-shipping.script-global-BMoCgX2a.js"), true ? [] : void 0, import.meta.url), "../snippets/collection-list/collection-list-6/collection-list-6.script-global.ts": () => __vitePreload(() => import("./collection-list-6.script-global-C__33kN0.js"), true ? [] : void 0, import.meta.url), "../snippets/currency-select/currency-select.ts": () => __vitePreload(() => import("./currency-select-BZYtqHC6.js"), true ? [] : void 0, import.meta.url), "../snippets/image-banner/image-banner-3/image-banner-3.script-global.ts": () => __vitePreload(() => import("./image-banner-3.script-global-BWtk8fb-.js"), true ? [] : void 0, import.meta.url), "../snippets/language-select/language-select.ts": () => __vitePreload(() => import("./language-select-U7IKv92z.js"), true ? [] : void 0, import.meta.url), "../snippets/menu/menu-hamburger/menu-hamburger.script-global.ts": () => __vitePreload(() => import("./menu-hamburger.script-global-BlqrVNex.js"), true ? [] : void 0, import.meta.url), "../snippets/menu/menu-horizontal/menu-horizontal.script-global.ts": () => __vitePreload(() => import("./menu-horizontal.script-global-ChUn-o_q.js"), true ? [] : void 0, import.meta.url), "../snippets/predictive-search/predictive-search.ts": () => __vitePreload(() => import("./predictive-search-CkifxbHk.js"), true ? [] : void 0, import.meta.url), "../snippets/predictive-search/types.ts": () => __vitePreload(() => Promise.resolve().then(() => types), true ? void 0 : void 0, import.meta.url), "../snippets/product-card/product-card/product-card.script-global.ts": () => __vitePreload(() => import("./product-card.script-global-C9y_Xodd.js"), true ? [] : void 0, import.meta.url), "../snippets/section-attr/section-attr.global.ts": () => __vitePreload(() => Promise.resolve().then(() => sectionAttr_global), true ? void 0 : void 0, import.meta.url), "../snippets/share/share.ts": () => __vitePreload(() => import("./share-CS9sIQzF.js"), true ? [] : void 0, import.meta.url), "../snippets/transform-list/transform-list.script-global.ts": () => __vitePreload(() => import("./transform-list.script-global-fyUZXBJB.js"), true ? [] : void 0, import.meta.url), "../snippets/transform-pill/transform-pill.script-global.ts": () => __vitePreload(() => import("./transform-pill.script-global-DEVMplhY.js"), true ? [] : void 0, import.meta.url), "../snippets/video/video.ts": () => __vitePreload(() => import("./video-Bcn54zC5.js"), true ? [] : void 0, import.meta.url) });
Object.values(snippetModules).forEach((module) => module());
const pageModules = /* @__PURE__ */ Object.assign({ "../pages/addresses/snippets/address-form/address-form.ts": () => __vitePreload(() => import("./address-form-1qm6h4fP.js"), true ? [] : void 0, import.meta.url), "../pages/product/main-product/main-product.script-global.ts": () => __vitePreload(() => import("./main-product.script-global-CPV6a2t8.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/pickup-availability-list/pickup-availability-list.ts": () => __vitePreload(() => import("./pickup-availability-list-BNIm_IUV.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/product-info-content/product-info-content.script-global.ts": () => __vitePreload(() => import("./product-info-content.script-global-B5okas_s.js"), true ? [] : void 0, import.meta.url), "../pages/product/snippets/product-recommendations/product-recommendations.script.ts": () => __vitePreload(() => import("./product-recommendations.script-BqXM6myG.js"), true ? [] : void 0, import.meta.url), "../pages/search-filters/main-collection/section-main-collection.script-global.ts": () => __vitePreload(() => import("./section-main-collection.script-global-CbSzmd8K.js"), true ? [] : void 0, import.meta.url) });
Object.values(pageModules).forEach((module) => module());
const SELECTORS = {
  PRICE: ".xo-price__item",
  COMPARE_AT_PRICE: ".xo-price__item.xo-price__item--del",
  BUTTON_ADD: ".shopify-payment-button__add",
  BUTTON_ADD_TEXT: ".xo-btn__text"
};
function updatePrice(targetProductId, price) {
  const priceEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.PRICE}`);
  priceEls.forEach((priceEl) => {
    priceEl.innerHTML = price;
  });
}
function updateCompareAtPrice(targetProductId, price) {
  const compareAtPriceEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.COMPARE_AT_PRICE}`);
  compareAtPriceEls.forEach((compareAtPriceEl) => {
    compareAtPriceEl.innerHTML = price;
  });
}
function soldOutMessage(targetProductId, message) {
  const buttonEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.BUTTON_ADD}`);
  buttonEls.forEach((buttonEl) => {
    const btnTextEl = buttonEl.querySelector(SELECTORS.BUTTON_ADD_TEXT);
    if (btnTextEl) {
      btnTextEl.innerHTML = message;
    }
    buttonEl.style.pointerEvents = "none";
  });
}
window.Xotiny = window.Xotiny || {};
window.Xotiny.updatePrice = updatePrice;
window.Xotiny.updateCompareAtPrice = updateCompareAtPrice;
window.Xotiny.soldOutMessage = soldOutMessage;
console.log("%c Fullframe theme by Xotiny ", "background:#243b90;color: #fff", "Learn more at https:/xotiny.com/");
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const sectionAttr_global = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  DOMLoaded as D,
  XoComponent as X,
  componentDefine as a,
  objectParse as b,
  customElements as c,
  delay as d,
  each as e,
  formatMoney as f,
  getAttrs as g,
  objectValues as o,
  storage as s
};
